import {
  afterRenderEffect,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  signal,
  viewChild,
} from '@angular/core'
import { Observable } from 'rxjs'
import { AppPaths } from 'src/app/app-routing.module'
import { Permissions } from 'src/app/core/enums/permissions.enum'
import { ProviderInfo } from 'src/app/shared/models/provider-info.model'

@Component({
  selector: 'app-vzo-data-layer-config',
  templateUrl: './vzo-data-layer-config.component.html',
  styleUrls: ['./vzo-data-layer-config.component.scss'],
  standalone: false,
})
export class VZODataLayerConfigComponent {
  @Output() closed = new EventEmitter<void>()
  @Input() isLayerSelectionVisible: boolean = false
  Permissions = Permissions
  AppPaths = AppPaths
  @Input() providerInfo$!: Observable<ProviderInfo>
  private readonly categoriesScroll =
    viewChild.required<ElementRef<HTMLDivElement>>('categoriesScroll')
  private readonly categoriesContent =
    viewChild.required<ElementRef<HTMLDivElement>>('categoriesContent')
  readonly hasOverflow = signal(false)

  constructor() {
    afterRenderEffect((onCleanup) => {
      const scrollContainer = this.categoriesScroll().nativeElement
      const content = this.categoriesContent().nativeElement
      const observer = new ResizeObserver(() => {
        this.hasOverflow.set(scrollContainer.scrollHeight > scrollContainer.clientHeight)
      })
      observer.observe(scrollContainer)
      observer.observe(content)
      onCleanup(() => observer.disconnect())
    })
  }

  toggleLayerSwitchVisibility() {
    this.isLayerSelectionVisible = !this.isLayerSelectionVisible
  }

  public close() {
    this.isLayerSelectionVisible = false
  }
}
